var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lg:flex md:flex mb-4"},[_c('base-input',{staticClass:"lg:w-1/2 md:w-1/2 w-full lg:mr-2 md:mr-2",attrs:{"label":"Enity ID","placeholder":"Enter Enity ID"}}),_c('base-input',{staticClass:"lg:w-1/2 md:w-1/2 w-full lg:ml-2 md:ml-2",attrs:{"label":" Company Name","placeholder":"Enter  Company Name"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }